import React, { useEffect, useState } from "react";
import { config } from "../config/config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";

const GradoList = ({ onEdit, onDelete, reloadTrigger }) => {
    const [grados, setGrados] = useState([]);

    const fetchGrados = () => {
        fetch(`${config.apiUrl}/grados`)
            .then((res) => res.json())
            .then(setGrados)
            .catch(console.error);
    };

    useEffect(() => {
        fetchGrados(); // Cargar grados al inicio y cada vez que cambie reloadTrigger
    }, [reloadTrigger]);

    return (
        <div className="container mt-5">
            <h2 className="mb-4">Lista de Grados</h2>
            <table className="table table-bordered table-striped table-dark">
                <thead className="thead-dark">
                <tr>
                    <th>Nombre del Grado</th>
                    <th>Maestro</th>
                    <th colSpan={2} className="text-center">Acciones</th>
                </tr>
                </thead>
                <tbody>
                {grados.map((grado) => (
                    <tr key={grado.grado_id}>
                        <td>{grado.nombre_grado}</td>
                        <td>
                            {grado.maestro_id ? (
                                // Asumiendo que la API devuelve el nombre del maestro
                                grado.maestro_nombre || "Maestro no asignado"
                            ) : (
                                "Maestro no asignado"
                            )}
                        </td>
                        <td className="text-center">
                            <button
                                className="btn btn-warning btn-sm mr-2"
                                onClick={() => onEdit(grado)}
                            >
                                <FontAwesomeIcon icon={faEdit} />
                            </button>
                        </td>
                        <td className="text-center">
                            <button
                                className="btn btn-danger btn-sm"
                                onClick={() => onDelete(grado.grado_id)}
                            >
                                <FontAwesomeIcon icon={faTrashAlt} />
                            </button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default GradoList;